<template>
  <div>
    <p v-if="plan_details.length < 1">
       {{$t("contract.no_contract")}}
    </p>
    <el-card 
      v-for="(plan, idx) in plan_details"
      :key="idx"
      class="box-card" 
      shadow="never"
    >
      <div slot="header" class="clearfix">
        <div>
            <span class="order-number">{{$t("contact.order_number")}} {{plan.payment}}</span>
            <span class="menbership text-title">{{getNameMembership(plan.package)}}</span>
            <span class="text-desc">${{plan.price_after_discount}}/user/{{getTimeMembership(plan.package)}}</span>
        </div>
        <span class="number-learner" type="text">{{plan.number_of_learner}} {{ $t('contract.learners') }}</span>
      </div>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="text-title">
            {{ $t('contract.contract_start') }}
          </div>
          <div class="text-desc">
            {{ $t('contract.contract_start_desc') }}
          </div>
          <div class="text-date box-date">
            {{formatDate(contract.contract_start_date)}}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="text-title">
            {{ $t('contract.contract_renewal') }}
          </div>
          <div class="text-desc">
            {{ $t('contract.contract_renewal_desc') }}
          </div>
          <div class="text-date box-date">
            {{endDateContract(contract.contract_start_date)}}
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import { propOr } from 'ramda'
  import { format, addYears } from 'date-fns'
  import { memberships } from '@/helpers/memberships'
  export default {
      props: {
        organization: {
          type: Object,
          default: () => {}
        },
        organizationId: {
        },
        dateFormat: {
          type: String,
          default: 'MM/dd/yyyy'
        },
      },
      data() {
        return {

        }
      },
      computed: {
        plan_details: propOr([], 'currentPlanDetails'),
        contract: propOr({}, 'currentContract'),
        ...mapGetters('contracts', [
          'currentPlanDetails',
          'currentContract'
        ])
      },
      methods: {
        formatDate(date) {
          return date ? format(new Date(date), this.dateFormat) : '--'
        },
        getNameMembership(membership_id) {
          if (membership_id in memberships) {
            return memberships[membership_id]["full_name"]
          }
          return ""
        },
        getTimeMembership(membership_id) {
          if (membership_id in memberships) {
            return memberships[membership_id]["time"]
          }
          return "year"
        },
        endDateContract(start_date) {
          if (!start_date)
          {
            return '--';
          }
          return format(addYears(new Date(start_date), 1), this.dateFormat)
        }
      },
      watch: {
        organization: {
          immediate: true,
          deep: true,
          handler() {
            return this.$store.dispatch('contracts/getCurrentPaymentContract', {organizationId: this.organizationId})
          }
        }
      }
  }
</script>

<style lang="scss" scoped>
  .box-card {
    .text-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 10px;
    }
    .menbership {
      display: block;
    }
    .text-desc {
      font-size: 16px;
      line-height: 24px;
      min-height: 48px;
    }
    .order-number {
      display: block;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 10px;
    }
    .text-date {
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
    }
    .box-date {
      background: #E6E6E6;
      border: 1px solid #E6E6E6;
      box-sizing: border-box;
      border-radius: 16px;
      padding: 20px;
      margin-top: 20px;
      max-width: 352px;
    }
    .number-learner {
      border: solid 2px #E6E6E6;
      float: right;
      padding: 6px 12px;
      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
      border-radius: 8px;
      margin-top: -48px;
    }
  }
</style>
